import { makeStyles } from "@material-ui/core/styles";

const fontSize75 = "0.75rem";
const fontSize875 = "0.875rem";

const FranchiseStyle = makeStyles((theme) => ({
  root: {
    width: "90%",
    margin: "1rem auto",
    padding: "2rem",
    boxShadow: "0px 2px 7px 1px rgb(224 224 224)",
    borderRadius: "4px",
    fontSize: fontSize875
  },
  table: {
    "& th": {
      borderRight: "1px solid rgba(224, 224, 224, 1)",
      color: theme.palette.common.white,
    },
    "& th:first-child": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
    "& td": {
      borderRight: "1px solid rgba(224, 224, 224, 1)",
    },
    "& td:first-child": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  table2: {
    "& td": {
      border: "none",
    },
  },
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  textGroup: {
    display: "flex",
    marginBottom: "5px",
    alignItems: "center",
    fontSize: fontSize875,
  },
  circularProgress: {
    textAlign: "center",
    marginTop: "1rem"
  }
}));

export default FranchiseStyle;
